import type { GeneratedAudio, GeneratedAudioParams, GeneratedAudioResponse } from "../types/generatedAudio";
import { ApiService } from "./ApiService";

export class GeneratedAudioService extends ApiService {
  static pathName = "/generated-audio";

  static getAll = (
    params?: GeneratedAudioParams,
  ): Promise<GeneratedAudioResponse> => {
    const queryParams: Record<string, string | number> = {};
    if (params?.spaceId) queryParams.spaceId = params.spaceId;
    if (params?.page) queryParams.page = params.page;
    if (params?.limit) queryParams.limit = params.limit;

    return ApiService.get(this.pathName, undefined, undefined, queryParams);
  };

  static getOne = (id: string): Promise<GeneratedAudio> => {
    return ApiService.get(`${this.pathName}/${id}`);
  };

  static rename = (id: string, name: string): Promise<GeneratedAudio> => {
    return ApiService.patch(`${this.pathName}/${id}`, { name });
  };

  static remove = (id: string) => {
    return ApiService.delete(`${this.pathName}/${id}`);
  };
}
